export default __webpack_public_path__ + "static/media/polgo-screenshot-06.a7aea2ba.png";